import React, { Component, Fragment } from "react";
import { withRouter , Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import api from "../../services/api";
import './API.css';
import { faEdit, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ModalInformacoesTecnicasAPI } from "./ModalInformacoesTecnicasAPI.jsx";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

export const CatalogoApiList =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.initialState = {
				fornecedoras: [],
				fornecedora: '',
				resultadoPesquisa: {},
                pesquisaExecutada : false,
				exibeModalInformacoesOrientacoesGerais: false,
			};
			
			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Informações Técnicas da Plataforma de Interoperabilidade</h1>
					</div>
					<div className="div-form1">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			} 

			this.setState({carregandoFornecedoras: true});

			api.get('/api/aplicacao-fornecedora/ambiente/P')
			.then(response => { 
				this.setState(
					{
						fornecedoras: response.data,
						carregandoFornecedoras: false,
					}
				);
				this.props.escondeAguardando();
			})
			.catch(erro => {
				this.props.escondeAguardando();
				this.setState({carregandoFornecedoras: false});
				console.log("Não foi possível recuperar as aplicações fornecedoras de produção: " + JSON.stringify(erro));
				this.props.exibeMensagemErro("Erro durante o carregamento das API's de produção.")
			});

		}

		renderForm() {
			const { resultadoPesquisa, pesquisaExecutada } = this.state;
			const { content } = resultadoPesquisa;
			const user = this.props.user;

			return(
				<div className="container-fluid">
					<ModalInformacoesTecnicasAPI
						titulo="Informações Técnicas da Plataforma de Interoperabilidade - Conecta GOV.BR" 
						visible={this.state.exibeModalInformacoesOrientacoesGerais}
						handleClose={() => this.setState({exibeModalInformacoesOrientacoesGerais: false})}
					/>
					<div className="br-form">
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>API:</label>
										{ this.state.fornecedoras.length > 0 && 
											<SelectSearch
												id="fornecedora"
												allOptionName="Todas"
												name="fornecedora"
												options={this.state.fornecedoras.map(fornecedora => ({ value: fornecedora.id, label: fornecedora.nome }))}
												includeAllOption={true}
												onChange={this.handleInputChange}
												value={this.state.fornecedora}
											/>
										}
										{this.state.carregandoFornecedoras === false && this.state.fornecedoras.length === 0 && 'Não foram encontradas APIs com os critérios informados.'}
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={this.pesquisar}>Pesquisar</button>
								<button type="button" className="button is-secondary" onClick={() => this.setState({exibeModalInformacoesOrientacoesGerais: true})}>
									Orientações Gerais
								</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()}>Limpar</button>
								<ButtonBack />
							</div>
						</div>

						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
											<th scope="col">API</th>
											<th scope="col">Órgão Fornecedor</th>
											<th scope="col">Órgão Operador de Dados</th>
											<th scope="col" style={{width: "5%"}}>Esferas</th>
											<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((fornecedora, index) =>
													<tr key={index} >
														<td>{fornecedora.nome}</td>
														<td>{fornecedora.orgao}</td>
														<td>{fornecedora.orgaoOperador ? fornecedora.orgaoOperador : ''}</td>

														<td>{fornecedora.esferasAdministrativas.map(esfera => <Fragment>{esfera.nome}<br/></Fragment>)}</td>
														
														<td className="text-center">
															<div className="actions">
																{ user.isMantenedor === true &&
																	<Link to={`/api/catalogo/edit/${fornecedora.id}`}>
																		<button type="button" title="Editar as informações técnicas da API">
																			<span className="sr-only">Editar informações Técnicas da API</span>
																			<FontAwesomeIcon icon={faEdit} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}

																<Link to={`/api/catalogo/detail/${fornecedora.id}`}>
																	<button type="button" title="Visualizar informações técnicas da API">
																		<span className="sr-only">Visualizar informações Técnicas da API</span>
																		<FontAwesomeIcon icon={faMagnifyingGlass} style={{color: "#1351b4"}} />
																	</button>
																</Link>
															</div>
														</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhuma API encontrada com os critérios informados.
							</div>
						}

					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState({[nome]: valor});
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];
			
			this.setState({
				...this.initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: {}
			}, () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada(pagina){

			const {fornecedora } = this.state;
			const criterioPesquisa = { fornecedora, pagina};
			const url = '/api/aplicacao-fornecedora/ambiente/producao/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando()
			api(options)
				.then(response => { 
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as API's. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then( () => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.props.limpaMensagem();
			this.setState({
				fornecedora: '',
				resultadoPesquisa: {},
				pesquisaExecutada : false,
			}, () => {
				this.props.deleteState(this.state, this.props.location.pathname);
			});
		}
		
	}

) // redux
); // router